import { Status } from './types';

export const translators = ['A', 'B', 'C', 'D'];

export const statuses = [Status.Translating, Status.WaitingForTranslator];
